<template>
  <div class="view-member-area-setup">
    <action-dispatcher
      action="product/getProduct"
      :parameters="$route.params.id"
      class="view-product-upsell"
    >
      <action-dispatcher
        action="membersSetup/get"
        :parameters="$route.params.id"
      >
        <setup ref="setupComponent" :setup="setup" />
      </action-dispatcher>
    </action-dispatcher>
  </div>
</template>

<script>
import Setup from "@/components/product/details/content/Setup";
import MemberAreaMixin from "@/mixins/memberArea.js";
import { mapState } from "vuex";

export default {
  components: { Setup },
  mixins: [MemberAreaMixin],
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersSetup", ["setup"]),
    subdomain() {
      return this.setup?.subdomain;
    }
  }
};
</script>
